import { render, staticRenderFns } from "./BillOFLanding.vue?vue&type=template&id=af564526&"
import script from "./BillOFLanding.vue?vue&type=script&lang=js&"
export * from "./BillOFLanding.vue?vue&type=script&lang=js&"
import style0 from "./BillOFLanding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports